 module Bookhus {
     export class Housegallery {
         private dataService: IHousegalleryDataService;
         private timer;
         public _hideExternal = false; 

         constructor() {
             this.dataService = new HousegalleryDataService();


             var currentPagenumber = parseInt($(`#housegallery`).data('page'));
             var ownpropertycount = parseInt($(`#housegallery`).data('ownpropertycount'));
             var totalpropertycount = parseInt($(`#housegallery`).data('totalpropertycount'));
             this._hideExternal = $(`#housegallery`).data('hideexternal') === "True";
             this.dataService.generatePagenumberSequence(currentPagenumber, ownpropertycount, totalpropertycount, this._hideExternal);

             this.setClickEvents();

             this.setAutostart();
         }
         
         private setClickEvents() {
             $(`#housegallery_back`).click(() => {
                 this.clearTimer();
                 this.back();
             });

             $(`#housegallery_forward`).click(() => {
                 this.clearTimer();
                 this.forward();
             });
         }

         private back() {
             var page = this.dataService.getPreviousPagenumber();
             this.loadAndRedraw(page, this._hideExternal);
         }

         private forward() {
             var page = this.dataService.getNextPagenumber();
             this.loadAndRedraw(page, this._hideExternal);
         }

         private loadAndRedraw(pagenumber: number, hideExternal: boolean = false) {
             var xhr = this.dataService.loadDataAjax(pagenumber, hideExternal);
             if (xhr != null) {
                 xhr.always(() => {
                     this.draw();
                 });
             }
             else {
                 this.draw();
             }
         }

         private draw() {
             var self = this;
             /*
                5494 - Fix 03-07-2018 Jonas - Fejlen opstod på en iphone den 07-01-2018 og er muligvis ikke længere aktuel.
                Der er tilføjet et null check i tilfælde det sker igen.
             */
             //Findes huset ikke.. Så lad hver med at gøre noget
             if (self.dataService.house == null || self.dataService.house == undefined) {
                 return false;
             }
             var url = "";
             if (self.dataService.house.domain) {
                 url = "http://" + self.dataService.house.domain;
             }

             var image = new Image();
             image.onload = function () {

                 $(`#housegallery`).attr("data-page", self.dataService.house.pagenumber);
                 $('#housegallery div.gallery-thumbs').css('opacity', 0);
                 //background-image: url('/Houseimage/{1}')
                 //$(`#housegallery`).attr("style", "background-image:url('/houseimage/" + this.dataService.house.mainImage + "'");
                 //$(`#housegalleryImg`).html('');
                 //var clone = $(`#housegalleryImg`).clone(false);
                 //clone.appendTo($('#housegalleryImg'));
                 $(`#housegalleryImg`).css({ backgroundImage: "url(" + url + "/houseimage/" + self.dataService.house.mainImage + "/600)" });
                 //$("#housegalleryImg div").animate({
                 //    opacity: 0
                 //}, 1000);

                 $(`#housegallery div.gallery-caption`).html(self.dataService.house.title);
                 $(`#housegallery div.gallery-copyright`).html(self.dataService.house.copyright);

                 $("#housegallery .gallery-button-book").attr("href", `${url}/book/${self.dataService.house.houseid}`);

                 $("#housegallery .gallery-button-book").attr("data-bookhusportal", url.length > 0 ? 'show' : '');
                 $("#housegallery .gallery-button-book").attr("data-propertyowner", self.dataService.house.companyName);
                 $("#housegallery .gallery-button-book").attr("data-encrypteddata", self.dataService.house.encryptedData);
                 $("#housegallery .gallery-button-book").attr("data-redirectto", `/book/${self.dataService.house.houseid}`);



                 $("#housegallery .gallery-button-info").attr("href", `${url}/house/${self.dataService.house.houseid}`);

                 $("#housegallery .gallery-button-info").attr("data-bookhusportal", url.length > 0 ? 'show' : '');
                 $("#housegallery .gallery-button-info").attr("data-propertyowner", self.dataService.house.companyName);
                 $("#housegallery .gallery-button-info").attr("data-encrypteddata", self.dataService.house.encryptedData);
                 $("#housegallery .gallery-button-info").attr("data-redirectto", `/house/${self.dataService.house.houseid}`);

                 var thumbs = "";
                 var houseImageIds = self.dataService.house.images;
                 var houseImageCount = houseImageIds.length;
                 var cnt = 1;
                 // Henter maks. 4 thumbs ekskl. det første billede, som bliver vist i stor
                 while (houseImageCount > 1 && cnt <= 4 && cnt < houseImageCount) {
                     thumbs += `<div class="gallery-thumb" style="background-image: url(${url}/Houseimage/${houseImageIds[cnt++]}/128);"></div>`;
                 }
                 $(`#housegallery div.gallery-thumbs`).html(thumbs);
                 $("#housegalleryImg div").animate({
                     opacity: 0
                 }, 1000);
                 $("#housegallery div.gallery-thumbs").animate({
                     opacity: 1
                 }, 1000);

             };
             image.src = url + "/houseimage/" + self.dataService.house.mainImage + "/600";
         }

         private setAutostart() {
             if ($(`#housegallery`).attr("data-autostart") === "True") {
                 this.timer = setInterval(() => {
                     this.forward();
                 }, 5000);
             }
         }

         private clearTimer() {
             if (this.timer != undefined) {
                 clearInterval(this.timer);
             }
         }
     }
 }